import BaseModel from '../core/BaseModel'
import moment from "moment";
import {constants} from "../services/constants";
export default class ReportWarrantyRepairModel extends BaseModel {
    constructor() {
        super({
                name: "report_warranty_repair",
                tableName: 'core_warranty_repair_product_serial_number'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                model_code_text:{
                    name: 'model_code_text',
                    type: "String",
                    label: 'Model',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if(!constants.isEmpty(data.product_serial_number.product)){
                                str = data.product_serial_number.product.model_code
                            }
                        }
                        data.model_code_text = str;
                    }
                },
                name_text:{
                    name: 'name_text',
                    type: "String",
                    label: 'Tên sản phẩm',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if(!constants.isEmpty(data.product_serial_number.product)){
                                str = data.product_serial_number.product.name
                            }
                        }
                        data.name_text = str;
                    }
                },
                categories_text:{
                    name: 'categories_text',
                    type: "String",
                    label: 'Loại sản phẩm',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if(!constants.isEmpty(data.product_serial_number.product)){
                                if(!constants.isEmpty(data.product_serial_number.product.categories)){
                                    str = data.product_serial_number.product.categories.name
                                }
                            }
                        }
                        data.categories_text = str;
                    }
                },
                serial_number_text:{
                    name: 'serial_number_text',
                    type: "String",
                    label: 'Serial number',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if(!constants.isEmpty(data.product_serial_number.serial_number)){
                                str = data.product_serial_number.serial_number
                            }
                        }
                        data.serial_number_text = str;
                    }
                },
                production_order_code_text:{
                    name: 'production_order_code_text',
                    type: "String",
                    label: 'Lệnh sản xuất',
                    width: 13,
                    sortable: false,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if(!constants.isEmpty(data.product_serial_number.production_order_code)){
                                str = data.product_serial_number.production_order_code
                            }
                        }
                        data.production_order_code_text = str;
                    }
                },
                activation_date_text: {
                    name: 'activation_date_text', 
                    type: "Date", 
                    label: 'Ngày kích hoạt',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.product_serial_number)){
                            if (!constants.isEmpty(data.product_serial_number.product_serial_number_info)){
                                if(!constants.isEmpty(data.product_serial_number.product_serial_number_info.activation_date)){
                                    str = data.product_serial_number.product_serial_number_info.activation_date
                                }
                            }
                        }
                        data.activation_date_text = str;
                    }
                },
                expired_activation_date_text: {
                    name: 'expired_activation_date_text', 
                    type: "String", 
                    label: 'Ngày hết hạn BH',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        var activation = ''
                        if (!constants.isEmpty(data.product_serial_number)){
                            if (!constants.isEmpty(data.product_serial_number.product_serial_number_info)){
                                if((!constants.isEmpty(data.product_serial_number.product_serial_number_info.warranty_status)) && data.product_serial_number.product_serial_number_info.warranty_status == 3){
                                    if(!constants.isEmpty(data.product_serial_number.product_serial_number_info.activation_date)){
                                        activation = data.product_serial_number.product_serial_number_info.activation_date
                                    }
                                    if(!constants.isEmpty(data.product_serial_number.product_serial_number_info.warranty_time)){
                                        if(!constants.isEmpty(data.product_serial_number.product_serial_number_info.warranty_unit)){
                                            if(activation !== ''){
                                                var expired_activation_date = moment(activation).add(data.product_serial_number.product_serial_number_info.warranty_time, data.product_serial_number.product_serial_number_info.warranty_unit);
                                                str = moment.tz(expired_activation_date, constants.timeZone()).format('DD/MM/YYYY');
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        data.expired_activation_date_text = str;
                    }
                },
                customer_name_text: {
                    name: 'customer_name_text', 
                    type: "String", 
                    label: 'Tên khách hàng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.customer_name)){
                            str = data.customer_name
                        }
                        data.customer_name_text = str;
                    }
                },
                customer_phone_text: {
                    name: 'customer_phone_text', 
                    type: "String", 
                    label: 'SĐT khách hàng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.customer_phone)){
                            str = data.customer_phone
                        }
                        data.customer_phone_text = str;
                    }
                },
                customer_address_text: {
                    name: 'customer_address_text', 
                    type: "String", 
                    label: 'Địa chỉ khách hàng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.customer_address)){
                            str = data.customer_address
                        }
                        data.customer_address_text = str;
                    }
                },
                creator_organization_name_text: {
                    name: 'creator_organization_name_text', 
                    type: "String", 
                    label: 'Đơn vị thực hiện',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.obj_creator_organization)){
                                str = data.obj_warranty_repair.obj_creator_organization.name
                            }
                        }
                        data.creator_organization_name_text = str
                    }
                },
                creator_organization_phone_text: {
                    name: 'creator_organization_phone_text', 
                    type: "String", 
                    label: 'SĐT đơn vị',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.obj_creator_organization)){
                                str = data.obj_warranty_repair.obj_creator_organization.phone_number.replace('+84', '0')
                            }
                        }
                        data.creator_organization_phone_text = str
                    }
                },
                creator_organization_provinces_text: {
                    name: 'creator_organization_provinces_text', 
                    type: "String", 
                    label: 'Tỉnh/TP của đơn vị',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.obj_creator_organization)){
                                if(!constants.isEmpty(data.obj_warranty_repair.obj_creator_organization.provinces)){
                                    str = data.obj_warranty_repair.obj_creator_organization.provinces.name
                                }
                            }
                        }
                        data.creator_organization_provinces_text = str
                    }
                },
                modifier_name_text: {
                    name: 'modifier_name_text', 
                    type: "String", 
                    label: 'Nhân viên cập nhật',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.obj_modifier)){
                                str = data.obj_warranty_repair.obj_modifier.full_name
                            }
                        }
                        data.modifier_name_text = str
                    }
                },
                receive_day_reception_text: {
                    name: 'receive_day_reception_text', 
                    type: "Date", 
                    label: 'Ngày tiếp nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.receive_day_reception )){
                                str = data.obj_warranty_repair.receive_day_reception 
                            }
                        }
                        data.receive_day_reception_text = str
                    }
                },
                receive_sender_text: {
                    name: 'receive_sender_text', 
                    type: "String", 
                    label: 'Đối tượng gửi',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(data.obj_warranty_repair.receive_sender == 0){
                                str ='Khách hàng'
                            }else if(data.obj_warranty_repair.receive_sender == 1){
                                str = 'Nhân viên đại lý'
                            }  
                        }
                        data.receive_sender_text = str
                    }
                },
                receive_sender_name_text: {
                    name: 'receive_sender_name_text', 
                    type: "String", 
                    label: 'Tên người gửi',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(data.obj_warranty_repair.receive_sender == 0){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.obj_customer_profile)){
                                        str = data.obj_warranty_repair.obj_receive_user.obj_customer_profile.full_name
                                    }
                                }
                            }else if(data.obj_warranty_repair.receive_sender == 1){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                    str = data.obj_warranty_repair.obj_receive_user.full_name
                                }
                            }
                        }
                        data.receive_sender_name_text = str
                    }
                },
                receive_sender_phone_text: {
                    name: 'receive_sender_phone_text', 
                    type: "String", 
                    label: 'SĐT người gửi',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(data.obj_warranty_repair.receive_sender == 0){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.obj_customer_profile)){
                                        str = data.obj_warranty_repair.obj_receive_user.obj_customer_profile.phone_number.replace('+84', '0')
                                    }
                                }
                            }else if(data.obj_warranty_repair.receive_sender == 1){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                    str = data.obj_warranty_repair.obj_receive_user.phone_number.replace('+84', '0')
                                }
                            }
                        }
                        data.receive_sender_phone_text = str
                    }
                },
                receive_sender_organization_text: {
                    name: 'receive_sender_organization_text', 
                    type: "String", 
                    label: 'Đơn vị của người gửi',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(data.obj_warranty_repair.receive_sender == 1){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.organization_account)){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.organization_account.organization)){
                                            str = data.obj_warranty_repair.obj_receive_user.organization_account.organization.name
                                        }
                                    }
                                }
                            }
                        }
                        data.receive_sender_organization_text = str
                    }
                },
                receive_method_text: {
                    name: 'receive_method_text', 
                    type: "String", 
                    label: 'Hình thức tiếp nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.receive_method)){
                                if(data.obj_warranty_repair.receive_method == 0){
                                    str = 'Tại trung tâm bảo hành'
                                }else if(data.obj_warranty_repair.receive_method == 1){
                                    str = 'Dịch vụ hỗ trợ tận nơi'
                                }
                            }
                        }
                        data.receive_method_text = str
                    }
                },
                receive_note_text: {
                    name: 'receive_note_text', 
                    type: "String", 
                    label: 'Ghi chú',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.receive_note)){
                                str = data.obj_warranty_repair.receive_note
                            }
                        }
                        data.receive_note_text = str
                    }
                },
                delivery_return_appointment_day_text: {
                    name: 'delivery_return_appointment_day_text', 
                    type: "Date", 
                    label: 'Ngày hẹn trả',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.delivery_return_appointment_day)){
                                str = data.obj_warranty_repair.delivery_return_appointment_day
                            }
                        }
                        data.delivery_return_appointment_day_text = str
                    }
                },
                delivery_relative_receiving_text: {
                    name: 'delivery_relative_receiving_text', 
                    type: "String", 
                    label: 'Đối tượng nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.delivery_relative_receiving)){
                                var relative = data.obj_warranty_repair.delivery_relative_receiving
                                if(relative == 0){
                                    str = 'Người gửi' 
                                }else if(relative == 1){
                                    str = 'Khách hàng' 
                                }else if(relative == 2){
                                    str = 'Nhân viên đại lý'
                                }
                            }
                        }
                        data.delivery_relative_receiving_text = str
                    }
                },
                delivery_relative_receiving_name_text: {
                    name: 'delivery_relative_receiving_name_text', 
                    type: "String", 
                    label: 'Tên người nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.delivery_relative_receiving)){
                                if(data.obj_warranty_repair.delivery_relative_receiving == 0){
                                    if(data.obj_warranty_repair.receive_sender == 0){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                            if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.obj_customer_profile)){
                                                str = data.obj_warranty_repair.obj_receive_user.obj_customer_profile.full_name
                                            }
                                        }
                                    }else if(data.obj_warranty_repair.receive_sender == 1){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                            str = data.obj_warranty_repair.obj_receive_user.full_name
                                        }
                                    }
                                }else if(data.obj_warranty_repair.delivery_relative_receiving == 1){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user)){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user.obj_customer_profile)){
                                            str = data.obj_warranty_repair.obj_delivery_user.obj_customer_profile.full_name
                                        }
                                    }
                                }else if(data.obj_warranty_repair.delivery_relative_receiving == 2){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user)){
                                        str = data.obj_warranty_repair.obj_delivery_user.full_name
                                    }
                                }
                                
                            }
                        }
                        data.delivery_relative_receiving_name_text = str
                    }
                },
                delivery_relative_receiving_phone_text: {
                    name: 'delivery_relative_receiving_phone_text', 
                    type: "String", 
                    label: 'SĐT người nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.delivery_relative_receiving)){
                                if(data.obj_warranty_repair.delivery_relative_receiving == 0){
                                    if(data.obj_warranty_repair.receive_sender == 0){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                            if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user.obj_customer_profile)){
                                                str = data.obj_warranty_repair.obj_receive_user.obj_customer_profile.phone_number.replace('+84', '0')
                                            }
                                        }
                                    }else if(data.obj_warranty_repair.receive_sender == 1){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_receive_user)){
                                            str = data.obj_warranty_repair.obj_receive_user.phone_number.replace('+84', '0')
                                        }
                                    }
                                }else if(data.obj_warranty_repair.delivery_relative_receiving == 1){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user)){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user.obj_customer_profile)){
                                            str = data.obj_warranty_repair.obj_delivery_user.obj_customer_profile.phone_number.replace('+84', '0')
                                        }
                                    }
                                }else if(data.obj_warranty_repair.delivery_relative_receiving == 2){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user)){
                                        str = data.obj_warranty_repair.obj_delivery_user.phone_number.replace('+84', '0')
                                    }
                                }
                                
                            }
                        }
                        data.delivery_relative_receiving_phone_text = str
                    }
                },
                delivery_relative_receiving_organization_text: {
                    name: 'delivery_relative_receiving_organization_text', 
                    type: "String", 
                    label: 'Đơn vị của người nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(data.obj_warranty_repair.delivery_relative_receiving == 2){
                                if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user)){
                                    if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user.organization_account)){
                                        if (!constants.isEmpty(data.obj_warranty_repair.obj_delivery_user.organization_account.organization)){
                                            str = data.obj_warranty_repair.obj_delivery_user.organization_account.organization.name
                                        }
                                    }
                                }
                            }
                        }
                        data.delivery_relative_receiving_organization_text = str
                    }
                },
                delivery_method_text: {
                    name: 'delivery_method_text', 
                    type: "String", 
                    label: 'Hình thức giao trả',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if (!constants.isEmpty(data.obj_warranty_repair.delivery_method)){
                                if(data.obj_warranty_repair.delivery_method == 0){
                                    str='Tại trung tâm bảo hành'  
                                }else if(data.obj_warranty_repair.delivery_method == 1){
                                    str = 'Giao tận nơi người nhận'
                                }
                           
                            }
                        }
                        data.delivery_method_text = str
                    }
                },
                delivery_address_text: {
                    name: 'delivery_address_text', 
                    type: "String", 
                    label: 'Địa chỉ nhận',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if(!constants.isEmpty(data.obj_warranty_repair.delivery_method)){
                                if(data.obj_warranty_repair.delivery_method == 1){
                                    var name_province = (!constants.isEmpty(data.obj_warranty_repair.province)) ? data.obj_warranty_repair.province.name:'';
                                    var name_district = (!constants.isEmpty(data.obj_warranty_repair.district)) ? data.obj_warranty_repair.district.name:'';
                                    var name_ward = (!constants.isEmpty(data.obj_warranty_repair.ward)) ? data.obj_warranty_repair.ward.name:'';
                                    var delivery_apartment_number = (!constants.isEmpty(data.obj_warranty_repair.delivery_apartment_number)) ? data.obj_warranty_repair.delivery_apartment_number.trim():'';
                                    if (
                                        !constants.isEmpty(name_province)
                                        && !constants.isEmpty(name_district)
                                        && !constants.isEmpty(name_ward)
                                        && !constants.isEmpty(delivery_apartment_number)
                                    ){
                                        str = delivery_apartment_number+', '+name_ward+', '+name_district+', '+name_province;
                                    }
                                }
                            }
                        }
                        data.delivery_address_text = str
                    }
                },
                code_text: {
                    name: 'code_text', 
                    type: "String", 
                    label: 'Mã dịch vụ',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if (!constants.isEmpty(data.obj_warranty_repair.code)){
                                str=data.obj_warranty_repair.code                      
                            }
                        }
                        data.code_text = str
                    }
                },
                type_service_text: {
                    name: 'type_service_text',
                    type: "String",
                    label: 'Loại dịch vụ',
                    width: 12,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_type)){
                            str=(!constants.isEmpty(data.service_type.name)) ?  data.service_type.name : ''    
                        }
                        data.type_service_text = str
                    }
                },
                parts_number_text: {
                    name: 'parts_number_text', 
                    type: "String", 
                    label: 'Đợt bảo trì',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.parts_number)){
                            str= 'Đợt '+data.parts_number  
                        }
                        data.parts_number_text = str
                    }
                },
                process_product_status_text: {
                    name: 'process_product_status', 
                    type: "String", 
                    label: 'Trạng thái thực hiện',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.process_status)){
                            str=constants.process_product_status(data.process_status)           
                        }
                        data.process_product_status_text = str
                    }
                },
                process_status_text: {
                    name: 'process_status_text', 
                    type: "String", 
                    label: 'Tiến độ thực hiện',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            str = constants.process_status(data.obj_warranty_repair.process_status)
                        }
                        data.process_status_text = str
                    }
                },
                technical_user_name_text: {
                    name: 'technical_user_name_text', 
                    type: "String", 
                    label: 'Nhân viên kỹ thuật',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.technical_user)){
                            str = (!constants.isEmpty(data.technical_user.full_name)) ? data.technical_user.full_name + ' - ' : ''
                            var phone =(!constants.isEmpty(data.technical_user.phone_number)) ? data.technical_user.phone_number.replace('+84', '0') : ''
                            str = str+phone
                        }
                        data.technical_user_name_text = str
                    }
                },
                check_presently_damaged_text: {
                    name: 'check_presently_damaged_text', 
                    type: "String", 
                    label: 'Hiện tượng hư hỏng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_presently_damaged)){
                            str =  data.check_presently_damaged
                        }
                        data.check_presently_damaged_text = str
                    }
                },
                type_failure_cause_text: {
                    name: 'type_failure_cause_text', 
                    type: "String", 
                    label: 'Loại nguyên nhân hư hỏng',
                    width: 14,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.type_failure_cause)){
                            str =  (!constants.isEmpty(data.type_failure_cause.name))?data.type_failure_cause.name : ''
                        }
                        data.type_failure_cause_text = str
                    }
                },
                check_cause_damage_text: {
                    name: 'check_cause_damage_text', 
                    type: "String", 
                    label: 'Nguyên nhân hư hỏng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_cause_damage)){
                            str =  data.check_cause_damage
                        }
                        data.check_cause_damage_text = str
                    }
                },
                check_proposed_solutions_text: {
                    name: 'check_proposed_solutions_text', 
                    type: "String", 
                    label: 'Giải pháp đề xuất',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_proposed_solutions)){
                            str =  data.check_proposed_solutions
                        }
                        data.check_proposed_solutions_text = str
                    }
                },
                check_result_text: {
                    name: 'check_result_text', 
                    type: "String", 
                    label: 'Kết quả kiểm tra',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_result)){
                            str =  constants.check_result(data.check_result)
                        }
                        data.check_result_text = str
                    }
                },
                check_reason_text: {
                    name: 'check_reason_text', 
                    type: "String", 
                    label: 'Nội dung/Lý do chi tiết',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_result)){
                            if(data.check_result == 1){
                                str = (!constants.isEmpty(data.check_reason_not_repairing)) ? data.check_reason_not_repairing : ''
                            }else if(data.check_result == 2){
                                str = (!constants.isEmpty(data.check_content_ask_customer)) ? data.check_content_ask_customer : ''
                            }else if(data.check_result == 3){
                                str = (!constants.isEmpty(data.check_reason_cancel_product )) ? data.check_reason_cancel_product : ''
                            }
                        }
                        data.check_reason_text = str
                    }
                },
                service_total_price_service_text: {
                    name: 'service_total_price_service_text', 
                    type: "Currency", 
                    label: 'Tổng cộng',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_total_price_service)){
                            str = data.service_total_price_service
                        }
                        data.service_total_price_service_text = str
                    }
                },
                service_total_discount_text: {
                    name: 'service_total_discount_text', 
                    type: "String", 
                    label: '%Giảm giá',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_total_discount)){
                            str = data.service_total_discount
                        }
                        data.service_total_discount_text = str
                    }
                },
                service_total_money_discount_text: {
                    name: 'service_total_money_discount_text', 
                    type: "Currency", 
                    label: 'Tiền giảm giá',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_total_money_discount)){
                            str = data.service_total_money_discount
                        }
                        data.service_total_money_discount_text = str
                    }
                },
                service_tax_text: {
                    name: 'service_tax_text', 
                    type: "String", 
                    label: '%Thuế GTGT',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_tax)){
                            str = data.service_tax
                        }
                        data.service_tax_text = str
                    }
                },
                service_money_tax_text: {
                    name: 'service_tax_text', 
                    type: "Currency", 
                    label: 'Tiền thuế GTGT',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_money_tax)){
                            str = data.service_money_tax
                        }
                        data.service_money_tax_text = str
                    }
                },
                service_total_price_payment_text: {
                    name: 'service_total_price_payment_text', 
                    type: "Currency", 
                    label: 'Thành tiền',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.service_total_price_payment)){
                            str = data.service_total_price_payment
                        }
                        data.service_total_price_payment_text = str
                    }
                },
                check_staff_comments_text: {
                    name: 'check_staff_comments_text', 
                    type: "String", 
                    label: 'Ý kiến nhân viên về sử dụng sản phẩm',
                    width: 15,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.check_staff_comments)){
                            str = data.check_staff_comments
                        }
                        data.check_staff_comments_text = str
                    }
                },
                modified_date_text: {
                    name: 'modified_date_text', 
                    type: "Date", 
                    label: 'Ngày giao trả',
                    width: 13,
                    computed: (data) => {
                        var str = '';
                        if (!constants.isEmpty(data.obj_warranty_repair)){
                            if (!constants.isEmpty(data.obj_warranty_repair.process_status)){
                                if (data.obj_warranty_repair.process_status == 4){
                                    if (!constants.isEmpty(data.obj_warranty_repair.modified_date)){
                                        str = data.obj_warranty_repair.modified_date
                                    } 
                                }
                            }  
                        }
                        data.modified_date_text = str
                    }
                },
                fied_detail: {
                    refs: `id
                        process_status
                        check_presently_damaged
                        check_cause_damage
                        check_proposed_solutions
                        check_result
                        check_reason_cancel_product
                        check_reason_not_repairing
                        check_content_ask_customer
                        check_staff_comments check_cause_damage
                        service_total_price_service
                        service_total_discount
                        service_total_money_discount
                        service_tax
                        service_money_tax
                        service_total_price_payment
                        check_maintenance_period
                        product_serial_number {
                            id
                            production_order_code
                            serial_number
                            product {
                                id
                                name
                                model_code
                                categories {id name}
                            }
                            product_serial_number_info {activation_date warranty_time warranty_unit warranty_status}
                        }
                        obj_warranty_repair {
                            id
                            receive_day_reception
                            receive_sender
                            delivery_method
                            code
                            process_status
                            obj_receive_user {
                                full_name
                                phone_number
                                obj_customer_profile {id full_name phone_number}
                                organization_account {
                                    organization {id name}
                                }
                            }
                            receive_method
                            receive_note
                            delivery_return_appointment_day
                            delivery_relative_receiving
                            obj_delivery_user {
                                full_name
                                phone_number
                                obj_customer_profile {id full_name phone_number address province{id name} district{id name} ward{id name}}
                                organization_account {
                                    organization {id name}
                                }
                            }
                            obj_creator_organization {
                                id
                                name
                                phone_number
                                provinces {id name}
                            }
                            obj_modifier {id full_name}
                            modified_date
                            delivery_apartment_number
                            province{id name}
                            district{id name}
                            ward{id name}
                        }
                        technical_user {full_name phone_number id}
                        type_failure_cause {code name}
                        service_type{code name}`,
                    display: false
                },
            },)
    }
}